import React from 'react';
import { BrandListingCard } from '../../../components';
import classNames from 'classnames';
import { filterListingsByBrandPremier, isArrayLength } from '../../../util/genericHelpers';
import { DEFAULT_LISTING_CARD_SIZES, UserType } from '../../../util/enums';
import { FormattedMessage } from 'react-intl';
import { createResourceLocatorString } from '../../../util/routes';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import routeConfiguration from '../../../routing/routeConfiguration';

import css from './Sections.module.css';

function ExploreBrands(props) {
  const { listings, intl, isLandingListingCard, isBrand, isBrandListings } = props;

  const noItemsMessage = intl.formatMessage({ id: 'ExploreBrands.noItems' });

  const history = useHistory();

  const useHistoryPush = (page, params = {}, search = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration(), params, search));
  };

  const brandListings = isArrayLength(listings) && filterListingsByBrandPremier(listings);

  return (
    <div
      className={classNames(
        css.topCollections,
        css.exploreBrands,
        css.blackBgWrapper,
        css.sectionPadding
      )}
    >
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="ExploreBrands.title" />
            </h2>
            <p>
              <FormattedMessage id="ExploreBrands.description" />
            </p>
          </div>
          <div className={css.rightSec}>
            <button
              className={css.viewbtn}
              onClick={() =>
                useHistoryPush('SearchPage', null, { pub_listingCategory: UserType.BRAND })
              }
            >
              {intl.formatMessage({ id: 'ExploreBrands.viewAll' })}
            </button>
          </div>
        </div>
        <div className={css.topCollectionsWrapper}>
          {isArrayLength(brandListings) ? (
            <>
              <div
                className={classNames(
                  css.topCollectionsContent,
                  isBrand ? css.brandCollectionsContent : null
                )}
              >
                {brandListings.map((l, index) => (
                  <BrandListingCard
                    isBrandListings={isBrandListings}
                    className={css.listingCard}
                    key={index}
                    listing={l}
                    showLightVersion
                    setActiveListing={() => {}}
                    renderSizes={DEFAULT_LISTING_CARD_SIZES}
                    isLandingListingCard={isLandingListingCard}
                    isBrand={isBrand}
                  />
                ))}
              </div>

              <div
                className={css.viewMore}
                role="button"
                onClick={() =>
                  useHistoryPush('SearchPage', null, { pub_listingCategory: UserType.BRAND })
                }
              >
                <button type="button" className={css.viewbtn}>
                  {intl.formatMessage({ id: 'ExploreBrands.viewAll' })}
                </button>
              </div>
            </>
          ) : (
            <div className={css.noItemsMessage}>{noItemsMessage}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExploreBrands;
